
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"line-height":"normal","text-indent":"0","text-align":"start","text-decoration-line":"none","text-decoration-style":"solid","text-decoration-color":"#000","text-transform":"none","block-progression":"tb","isolation":"auto","mix-blend-mode":"normal"},attrs:{"d":"M10 3L4 9l6 6v-4h7c2.785 0 5 2.215 5 5s-2.215 5-5 5h-3a2 2 0 100 4h3c4.675 0 8.431-3.658 8.844-8.23A2 2 0 0026 16c0-4.947-4.053-9-9-9h-7V3z","font-weight":"400","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    